import { STORE_NAME } from './reducer';
/**
 * この機能の状態。
 *
 * @param {IReduxState} state - The redux state.
 * @returns {ISessionTimeoutState}
 */
export function getSessionTimeoutState(state) {
    return state[STORE_NAME];
}
/**
 * 部屋のタイムアウト設定。
 *
 * @param {IReduxState} state - The redux state.
 * @returns {ISessionTimeoutConfig}
 */
export function getSessionTimeoutConfig(state) {
    return getSessionTimeoutState(state).config;
}
/**
 * 先に来るほうの残り(ms)。切らない設定なら null。
 *
 * 無操作と上限のどちらで切れるかは常に「短いほう」。表示も判定もこれを見る。
 *
 * @param {IReduxState} state - The redux state.
 * @returns {number|null}
 */
export function getSessionTimeoutLeftMs(state) {
    const s = getSessionTimeoutState(state);
    if (!s.config.enabled || s.idleLeftMs === null || s.maxLeftMs === null) {
        return null;
    }
    return Math.min(s.idleLeftMs, s.maxLeftMs);
}
/**
 * 予告を出している理由。出していなければ null。
 *
 * @param {IReduxState} state - The redux state.
 * @returns {'idle'|'max'|null}
 */
export function getSessionTimeoutWarning(state) {
    return getSessionTimeoutState(state).warning;
}
/**
 * 残りミリ秒を mm:ss にする。
 *
 * 負の値は 00:00 に丸める。退出処理が走るまでの数百ミリ秒で
 * マイナス表示が出るのを防ぐ。
 *
 * @param {number} ms - 残りミリ秒。
 * @returns {string}
 */
export function formatLeft(ms) {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
